
export const INITIAL_LOCATION_CATEGORIES = [
  'location_categories.province',
  'location_categories.project_name',
  'location_categories.mass_transit',
  'location_categories.shopping_mall',
  'location_categories.university',
  'location_categories.road',
  'location_categories.hospital',
  'location_categories.park',
  'location_categories.airport',
  'location_categories.popular_location',
];

export const DEFAULT_PRICE_RANGES = {
  MIN: [0, 500000, 1000000, 1500000, 2000000],
  MAX: [500000, 1000000, 1500000, 2000000]
};

export const DEFAULT_AREA_RANGES = {
  MIN: [0, 10, 20, 30, 40],
  MAX: [10, 20, 30, 40, 50]
};

export const DEFAULT_PRICE_VALUES = {
  MIN: 0,
  MAX: 10000000,
  MIN_INPUT: '0',
  MAX_INPUT: '10,000,000'
};

export const DEFAULT_AREA_VALUES = {
  MIN: 0,
  MAX: 1000,
  MIN_INPUT: '0',
  MAX_INPUT: '1,000'
};

export const DEFAULT_SEARCH_VALUES = {
  TRANSACTION_TYPE_KEY: 'sell', // ใช้ translation key แทน hardcoded value
  DEBOUNCE_DELAY: 300,
  SEARCH_DEBOUNCE_DELAY: 100,
  PAGE_SIZE: 20,
  DROPDOWN_PAGE_SIZE: 10
};

export const LOCATION_TYPE_MAPPING: { [key: string]: number } = {
  'location_categories.province': 0,
  'location_categories.transportation': 11,
  'location_categories.education_facility': 17,
  'location_categories.shopping_facility': 20,
  'location_categories.healthcare_facility': 9,
  'location_categories.recreation_facility': 8,
  'location_categories.highway': 1,
  'location_categories.route': 2,
  'location_categories.project_name': -1
};

export const CACHE_CONFIG = {
  CAPACITY: 100,
  TTL: 86400000, // 24 hours
  LOCATION_CACHE_CAPACITY: 50
};

export const TYPE_IDS = {
  PROVINCE: 0,
  PROJECT: -1,
  MASS_TRANSIT: 10,
  SHOPPING_MALL: 11,
  UNIVERSITY: 17,
  ROAD: 20,
  HOSPITAL: 9,
  PARK: 8,
  AIRPORT: 1,
  POPULAR_LOCATION: 2
};

export const LOCATION_WITH_CHILDREN_ENDPOINTS = [
  '/api/location/getLocationByLocationTypeId?id=8', // สวนสาธารณะ
  '/api/location/getLocationByLocationTypeId?id=1', // สนามบิน
  '/api/location/getLocationByLocationTypeId?id=2', // สถานที่ยอดนิยม
  '/api/location/getLocationByLocationTypeId?id=10' // รถไฟฟ้า
]; 